import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import React from 'react'
import { TreeNavigatorDataSchema, TreeNavigatorUISchema } from './types'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'
import { HorizontalTree } from './TreeNavigatorContentV2HorizontalTree'
import { TreeNavigatorActions } from './components/TreeNavigatorActions'

export function TreeNavigatorContentV2({
  uiSchema,
  dataSchema,
  tileFilters,
  tileContainerRef,
}: {
  uiSchema: TreeNavigatorUISchema
  dataSchema: TreeNavigatorDataSchema
  tileFilters?: React.ReactNode
  tileContainerRef: React.RefObject<HTMLDivElement>
}) {
  const { title = undefined, description = undefined, emphasizeHeader } = uiSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)
  const [selectedPathNodeIds, setSelectedPathNodeIds] = React.useState<number[]>([])
  const selectedPathNodes = React.useMemo(() => {
    const nodeById = new Map(dataSchema.data.nodes.map((node) => [node.id, node]))
    return selectedPathNodeIds
      .map((nodeId) => nodeById.get(nodeId))
      .filter((node): node is (typeof dataSchema.data.nodes)[number] => !!node)
  }, [dataSchema, selectedPathNodeIds])

  return (
    <div className="relative flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>
            {uiSchema.treeConfig.treeActions && uiSchema.treeConfig.treeActions.length > 0 && (
              <TreeNavigatorActions actions={uiSchema.treeConfig.treeActions} selectedPathNodes={selectedPathNodes} />
            )}
            {tileFilters}
          </ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div className={clsx('px-0.5', { 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <div className={clsx('flex h-full w-full overflow-x-auto overflow-y-auto')}>
          <HorizontalTree
            uiSchema={uiSchema}
            dataSchema={dataSchema}
            tileContainerRef={tileContainerRef}
            selectedPath={selectedPathNodeIds}
            setSelectedPath={setSelectedPathNodeIds}
          />
        </div>
      </div>
    </div>
  )
}
